import React, { useState, useEffect, useRef } from "react";
import { Navigate, useLocation, useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import "../../admin_tools.css";
import BackIcon from "../../../../assets/communication/Back.svg";
import { ADMIN_TOOLS_MATTER_LIST } from "../../../../routes";
import { Loader } from "@progress/kendo-react-indicators";
import { MatterForm } from "./matter_form";
import { createMatter } from "../../../../store/matter";

export const AddMatter = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const {
        update_data,
        update_error,
        update_loading
    } = useSelector((state) => state.matter);

    const handleSaveMatter = (data) => {
        dispatch(createMatter({ data })).then(() => {
            navigate(ADMIN_TOOLS_MATTER_LIST)
        })
    }
    return (
        <>
            <div className="detail-body">
                {update_loading || loading ? (
                    <Loader
                        type="infinite-spinner"
                        style={{
                            display: "flex",
                            alignItems: "center",
                            width: "40px",
                            margin: "auto",
                            justifyContent: "center",
                            height: "100vh",
                        }}
                    />
                ) : (
                    <>
                        <div className="detail-header">
                            <div className="categoryback-group-div" onClick={() => navigate(ADMIN_TOOLS_MATTER_LIST)}>
                                <img src={BackIcon} className="categoryback-icon" />
                                <span className="categoryback-label">Back</span>
                            </div>
                        </div>
                        <div className="detail-content">
                            <MatterForm
                                data={null}
                                isEdit={true}
                                isCreate = {true}
                                submitForm={handleSaveMatter}
                                setLoading={setLoading}
                            />

                        </div>
                    </>
                )}

            </div>
        </>

    );
};